<template>
  <div>
    <p class="goldenP">
      <img
        style="width: 20px; margin-right: 10px; margin-left: 10px"
        src="@/assets/leadercup.svg"
      />{{ $t("LanguageEn.leaderboard") }}
    </p>
  </div>
</template>

<script>
export default {
  name: "Glb",
  props: {
    //   text: String,
  },
};
</script>

<style scoped>
.goldenP {
  background: #2c2d31;
  height: 45px;
  color: #e6e6e6;
  font-weight: bold;
  padding-top: 5%;
  font-size: 14px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  padding-left: 10px;
}
</style>
